import { Ivy } from "@/fonts/spaceGrotesk";
import Image from "next/image";


export default function Box( { icon , title, desc , className , visible }: { icon: string, title: string, desc: string, className?: string, visible? : boolean } ) {
// if visible is true, so use border-red-600, else use border-gold-vibrant
const bg = visible ? "!bg-gold-soft" : "bg-black"
const textColor = visible ? "text-black" : "text-gold-soft"
   const brightness = visible ? "brightness-0" : "brightness-100"
    return (
        <div className={`badge  m-4 w-full max-w-[320px] min-w-[300px] border-gold-vibrant ${bg} ${textColor} relative flex flex-col justify-center items-center bg-transparent p-4 text-sm rounded-3xl border-2 shadow-md   hover:scale-[1.01]  cursor-pointer  transition-all    duration-300    shadow-gold-vibrant/50  ${className}`}>
  <Image 
  className={`p-4 filter  ${brightness}	`}
  src={`${process.env.NEXT_PUBLIC_URL}/stars/${icon}`}
    alt={icon}
    
    width={200}
    height={200}
    />
    <h1 className={`${Ivy.className} ${textColor} mb-3`}>
        {title}
    </h1>
    <span
    className={`text-center ${textColor} px-3`}>
       {desc}
    </span>
        </div>
    )
    }